import React from 'react';
import { connect } from 'react-redux';
import ResourcesPage from '../components/ResourcesPage';
import { domainPath } from '../App';

class ResourcesContainer extends React.Component<any> {
    render() {
        const { user } = this.props;

        const accessToken = user?.user?.accessToken || '';

        return (
            <ResourcesPage
                domain={domainPath}
                accessToken={accessToken}
            />
        );
    }
}

const mapStateToProps = (state: any) => ({
    user: state.user || {}
});

export default connect(mapStateToProps)(ResourcesContainer);
